import React from 'react';
import { IconMap, IconList, IconPlus, IconCalendarEvent, IconUser, IconStar, IconSpeakerphone } from '@tabler/icons-react';

export default function Navigation({ user, activeView, onMapClick, onListClick, onCreateClick, onTariffsClick, onMyAdsClick, onBookingsClick, onProfileClick }) {
    const tabs = [
        { id: 'map', label: 'Карта', icon: IconMap, onClick: onMapClick },
        { id: 'list', label: 'Все заявки', icon: IconList, onClick: onListClick },
        { id: 'form', label: 'Создать', icon: IconPlus, onClick: onCreateClick, primary: true },
        { id: 'tariffs', label: 'Тарифы', icon: IconStar, onClick: onTariffsClick },
    ];
    
    // ✅ «Мои объявления» доступны всем ролям
    if (user) {
        tabs.push({ id: 'myAds', label: 'Мои заявки', icon: IconSpeakerphone, onClick: onMyAdsClick });
    }
    
    tabs.push({ id: 'myBookings', label: 'Сделки', icon: IconCalendarEvent, onClick: onBookingsClick });
    tabs.push({ id: 'profile', label: 'Профиль', icon: IconUser, onClick: onProfileClick });

    return (
        <nav className="sticky top-0 z-40 bg-industrial-bg border-b border-industrial-bg2 shadow-medium">
            <div className="max-w-7xl mx-auto px-2 sm:px-4 flex flex-wrap gap-1 justify-center sm:justify-start">
                {tabs.map(tab => {
                    const Icon = tab.icon;
                    const isActive = activeView === tab.id;
                    
                    return (
                        <button key={tab.id} onClick={tab.onClick}
                            className={
                                'flex items-center gap-1.5 sm:gap-2 px-2 sm:px-4 py-3 sm:py-4 text-xs sm:text-sm font-bold transition border-b-2 cursor-pointer uppercase tracking-wide ' +
                                (tab.primary
                                    ? 'text-industrial-bg bg-gold rounded-t-lg border-transparent hover:bg-gold-hover'
                                    : isActive
                                        ? 'text-gold border-gold bg-transparent'
                                        : 'text-industrial-gray border-transparent hover:text-gold hover:border-gold/50 bg-transparent')
                            }
                        >
                            <Icon size={16} className="sm:hidden" /> <Icon size={18} className="hidden sm:inline" /> {tab.label}
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}